import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideState, provideStore } from "@ngrx/store";
import { provideEffects } from "@ngrx/effects";
import { PublicationEffects } from "./store/effects/publication.effects";
import { publicationReducer } from "./store/reducers/publication.reducer";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { DictionaryEffects } from "./store/effects/dictionary.effects";
import { dictionaryReducer } from "./store/reducers/dictionary.reducer";
import { userReducer } from "./store/reducers/user.reducer";
import { UserEffects } from "./store/effects/user.effects";
import { httpErrorInterceptor } from "./interceptors/http-error-interceptor.service";
import { ErrorEffects } from "./store/effects/error.effects";
import { credentialsInterceptor } from "./interceptors/credentials.interceptor";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptors([httpErrorInterceptor, credentialsInterceptor]),
        ),
        provideStore(),
        provideState("publication", publicationReducer),
        provideState("dictionary", dictionaryReducer),
        provideState("user", userReducer),
        provideEffects([
            PublicationEffects,
            DictionaryEffects,
            UserEffects,
            ErrorEffects,
        ]),
        provideStoreDevtools({ maxAge: 25, logOnly: false }),
    ],
};
